export const mobileWidth = '425px';
export const tabletWidth = '768px';
export const desktopWidth = '1024px';
export const largeDesktopWidth = '1400px';
